import { Box, Card } from "@mui/material";
import { executeGameAction } from "api/game/gameActions";
import * as GameCard from "components/pages/game/GameCard";
import { CardType } from "models/CardType";
import { useSnackbar } from "notistack";
import React from "react";
import { useParams } from "react-router-dom";

export interface Props {
  cards: CardType[];
}

export const Component: React.FC<Props> = ({ cards }) => {
  const { gameId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const onClick = (cardName: string) => {
    if (gameId === undefined) {
      console.error("Game ID is undefined");
      return;
    }

    executeGameAction({
      gameId,
      ActionData: {
        card: cardName,
      },
      ActionId: "SELECT_CARD",
      DecisionId: "DISCARD_CARD",
      enqueueSnackbar,
    });
  };

  return (
    <Card
      sx={{
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h2>Choose Card to Discard</h2>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: "10px",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {cards.map((card) => (
          <Box
            sx={{
              padding: "10px",
            }}
          >
            <GameCard.Component
              key={card.name}
              name={card.name}
              isCorporation={card.isCorporation}
              isPrelude={card.cardType === "PRELUDE"}
              tooltip={card.tooltip}
              onClick={() => onClick(card.name)}
            />
          </Box>
        ))}
      </Box>
    </Card>
  );
};

Component.displayName = "DiscardCard";
